module.exports = __webpack_public_path__ + "static/media/NewT_Artwork 2.a2f913cd.jpg";